/// <amd-module name="Wit/LinkedWorkItemsDropdown/LinkedWorkItemsBaseDetailViewService" />
import { getTFSProject, IProjectData } from "Tfs/Platform/Page";
import { IReadyableReadonlyObservableArray, ReadyableObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, VssService } from "VSS/Platform/Context";
import { traceException } from "VSS/Platform/Trace";
import { WorkItem, WorkItemExpand } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { getLinkedWorkItemsService } from "./LinkedWorkItemsService";
import { IWorkItemEntry, workItemToListBoxItem } from "./Util/Data";

export abstract class LinkedWorkItemsBaseDetailViewService extends VssService {
    protected linkedWorkItemIds = new Set<string>();
    protected linkedWorkItems = new ReadyableObservableArray<IWorkItemEntry>([]);
    protected project: IProjectData;

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        this.project = getTFSProject(pageContext)!;
    }

    public getLinkedWorkItems(projectId: string, repositoryId: string, id: string | number): IReadyableReadonlyObservableArray<IWorkItemEntry> {
        if (!this.linkedWorkItems.ready.value) {
            const linkedWorkItemService = getLinkedWorkItemsService(this.pageContext);

            const idsPromise: Promise<number[]> = this.getLinkedWorkItemPromise(projectId, repositoryId, id);

            if (idsPromise) {
                idsPromise
                    .then(queryResult => {
                        this.linkedWorkItemIds.clear();

                        if (queryResult.length > 0) {
                            queryResult.forEach(x => this.linkedWorkItemIds.add(x.toString()));
                            return linkedWorkItemService.getWorkItems(queryResult, this.project.name, WorkItemExpand.Relations);
                        } else {
                            return [];
                        }
                    })
                    .then(resultItems => {
                        this.linkedWorkItems.value = resultItems.map((workItem: WorkItem) => workItemToListBoxItem(this.pageContext, workItem));
                        this.linkedWorkItems.ready.value = true;
                    })
                    .catch(error => {
                        console.error(error);
                        traceException(this.pageContext, "Repos", "LinkedWorkItemsBaseDetailViewService.getLinkedWorkItems", error);
                        this.linkedWorkItems.value = [];
                        this.linkedWorkItems.ready.value = true;
                    });
            }
        }

        return this.linkedWorkItems;
    }

    protected abstract getLinkedWorkItemPromise(projectId: string, repositoryId: string, id: string | number): Promise<number[]>;
}
